import type {RequestFilter} from './types';
import {authStore} from '../authentication/AuthenticationStore';

export const addPayoutMethodFilter: RequestFilter = {
  matchers: [
    {
      urlPath: /\/graphql\/multiregion/,
      method: 'POST',
      body: /CreateV2OutboundSetupIntentMutation/,
    },
  ],

  filterRequest: (requestData) => {
    const selectedApiKeyAndType = authStore.getApiKey('external_account');

    if (!selectedApiKeyAndType) {
      throw new Error('User has not stored external_account key');
    }

    const updatedRequest = {
      ...requestData.request,
      headers: {
        ...requestData.request.headers,
        Authorization: `Bearer ${selectedApiKeyAndType.key}`,
      },
    };

    return {
      ...requestData,
      request: updatedRequest,
    };
  },
};
